module.exports = __webpack_public_path__ + "img/UN_Women_Spurning06.dfdc4d48.gif";